export const getPadding = key => _keyValuePairs[key] || _keyValuePairs['Default'];

const _keyValuePairs = {
  None: '0',
  Footer: '2rem 2rem 0 2rem',
  Default: '2rem',
};
